import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Phone, Facebook, MapPin, Scissors, Droplets, PawPrint, Ear } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';

const Home = () => {
  const [activeTestimonial, setActiveTestimonial] = useState(0);

  const services = [
  {
    id: 'furdes-szaritas',
    icon: <Droplets className="w-12 h-12" />,
    title: 'Fürdés & Szárítás',
    description: 'Professzionális fürdőszolgáltatás prémium samponokkal és kondicionálókkal',
    image: 'https://images.unsplash.com/photo-1597595735781-6a57fb8e3e3d'
  },
  {
    id: 'szorvagas-formazas',
    icon: <Scissors className="w-12 h-12" />,
    title: 'Szőrvágás & Formázás',
    description: 'Fajtaspecifikus és egyedi szőrvágási stílusok',
    image: 'https://images.unsplash.com/photo-1719464454959-9cf304ef4774'
  },
  {
    id: 'koromvagas',
    icon: <PawPrint className="w-12 h-12" />,
    title: 'Körömvágás',
    description: 'Biztonságos és precíz körömápolás',
    image: 'https://images.unsplash.com/photo-1611173622933-91942d394b04'
  },
  {
    id: 'fulapolas',
    icon: <Ear className="w-12 h-12" />,
    title: 'Fülápolás',
    description: 'Alapos és kíméletes fültisztítás',
    image: 'https://images.unsplash.com/photo-1647002380358-fc70ed2f04e0'
  }];


  const testimonials = [
  {
    id: 'nagy-eva',
    name: 'Nagy Éva',
    dog: 'Morzsi (Yorkshire Terrier)',
    text: 'Csodálatos munkát végeznek! Morzsi mindig boldogan jön haza, és gyönyörűen néz ki. Csak ajánlani tudom!',
    rating: 5
  },
  {
    id: 'kovacs-peter',
    name: 'Kovács Péter',
    dog: 'Rex (Golden Retriever)',
    text: 'Profi hozzáállás, kedves kiszolgálás. Rex imádja a fürdést itt, és én is elégedett vagyok az eredménnyel.',
    rating: 5
  },
  {
    id: 'szabo-anna',
    name: 'Szabó Anna',
    dog: 'Cuki (Puli)',
    text: 'Végre találtam egy helyet, ahol értik Cuki speciális szőrápolási igényeit. Kiváló szakemberek!',
    rating: 5
  }];


  const beforeAfterImages = [
  {
    id: 'ba-yorkshire-terrier',
    before: 'https://customer-assets.emergentagent.com/job_pup-salon-preview/artifacts/61p5fc8r_att.TFqJD4qUwZ7I-3DXerDNaE6LyfDo_7POxHrE-dK0pwA.jpg',
    after: 'https://customer-assets.emergentagent.com/job_pup-salon-preview/artifacts/3zt16jgn_att.ESlZXad-vjYi6fE77oDlK75BtE70iIx8c3Tu5B9QMMg.jpg',
    title: 'Yorkshire Terrier'
  },
  {
    id: 'ba-yorkis',
    before: 'https://customer-assets.emergentagent.com/job_pup-salon-preview/artifacts/qoouteoy_att.Rc7WlBruDhQPGXeRGm85XX_xefmhycDzVZEjtT2NBII.jpg',
    after: 'https://customer-assets.emergentagent.com/job_pup-salon-preview/artifacts/rqw62cyz_att.8_SRBwCuIha5rPUV1YBvQBp_1wVUIqAA3LcyxmDXzjA.jpg',
    title: 'Yorkis'
  },
  {
    id: 'ba-kulonleges-fajta',
    before: 'https://customer-assets.emergentagent.com/job_pup-salon-preview/artifacts/5q3guhwf_att.gUDzFQ2Ybjl4oykDANRMxzaCp3bZ9omJm8gsLnjszV0.jpg',
    after: 'https://customer-assets.emergentagent.com/job_pup-salon-preview/artifacts/c5p11cbu_att.L680TocULyLJiWU7MXcf1sBWXl52GiVSRrercefCThA.jpg',
    title: 'Különleges fajta'
  }];


  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-cyan-50">
      {/* Header */}
      <header className="bg-white/80 backdrop-blur-md shadow-sm sticky top-0 z-50 border-b border-cyan-100">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center gap-3">
          <div className="flex items-center gap-2 sm:gap-3 min-w-0 flex-1">
            <PawPrint className="w-7 h-7 sm:w-8 sm:h-8 text-cyan-600 flex-shrink-0" />
            <h1 className="text-lg sm:text-2xl font-bold bg-gradient-to-r from-cyan-600 to-teal-600 bg-clip-text text-transparent truncate">
              Mázli Kutyakozmetika
            </h1>
          </div>
          <Button
            className="bg-gradient-to-r from-cyan-500 to-teal-500 hover:from-cyan-600 hover:to-teal-600 text-white font-semibold px-3 sm:px-6 py-2 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 flex-shrink-0"
            onClick={() => window.location.href = 'tel:06305441284'}>

            <Phone className="w-4 h-4 sm:mr-2" />
            <span className="hidden sm:inline">Bejelentkezés</span>
          </Button>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative overflow-hidden py-16 sm:py-20 md:py-32">
        <div className="absolute inset-0 bg-gradient-to-br from-cyan-100/50 via-teal-100/30 to-lime-100/50"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
            <div className="space-y-5 sm:space-y-6 animate-fade-in min-w-0">
              <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
                <span className="bg-gradient-to-r from-cyan-600 via-teal-600 to-lime-600 bg-clip-text text-transparent">
                  Mázli kutyakozmetika Miskolcon, az Észak-Kilián szívében
                </span>
              </h2>
              <p className="text-xl sm:text-2xl md:text-3xl text-gray-700 font-medium">
                Ahol a kedvencek megszépülnek
              </p>
              <p className="text-base sm:text-lg text-gray-600 leading-relaxed">Professzionális kutyakozmetika Miskolcon, az Észak-Kilián szívében. Ha megbízható miskolci kutyakozmetikát keresel, jó helyen jársz: szeretettel, türelemmel és szakértelemmel gondozom négylábú barátaidat, legyen szó nyírásról, fürdetésről vagy teljes körű ápolásról.


              </p>
              <div className="flex flex-col sm:flex-row gap-4 pt-2 sm:pt-4">
                <Button
                  size="lg"
                  className="bg-gradient-to-r from-cyan-500 to-teal-500 hover:from-cyan-600 hover:to-teal-600 text-white font-bold px-6 sm:px-8 py-5 sm:py-6 text-base sm:text-lg rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105 w-full sm:w-auto"
                  onClick={() => window.location.href = 'tel:06305441284'}>

                  <Phone className="w-5 h-5 mr-2" />
                  06 30 544 1284
                </Button>
                <Button
                  size="lg"
                  variant="outline"
                  className="border-2 border-cyan-500 text-cyan-700 hover:bg-cyan-50 font-semibold px-6 sm:px-8 py-5 sm:py-6 text-base sm:text-lg rounded-full transition-all duration-300 w-full sm:w-auto"
                  onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}>

                  Szolgáltatások
                </Button>
              </div>
            </div>
            <div className="relative min-w-0">
              <div className="absolute -inset-4 bg-gradient-to-r from-cyan-400 to-teal-400 rounded-3xl blur-2xl opacity-20 animate-pulse"></div>
              <img
                src="https://images.unsplash.com/photo-1611173622933-91942d394b04?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxkb2clMjBncm9vbWluZ3xlbnwwfHx8fDE3NzU4NDA0NDl8MA&ixlib=rb-4.1.0&q=85"
                alt="Ápolt kutya a Mázli Kutyakozmetikában – kutya nyírás és ápolás Miskolc Észak-Kilián"
                className="relative rounded-3xl shadow-2xl w-full h-auto object-cover transform hover:scale-105 transition-transform duration-500" />

            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-16 sm:py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-cyan-600 to-teal-600 bg-clip-text text-transparent">Szolgáltatásaim

            </h2>
            <p className="text-lg sm:text-xl text-gray-600 max-w-2xl mx-auto">
              Professzionális ápolás minden méretű és fajtájú kutya számára
            </p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            {services.map((service) =>
            <Card
              key={service.id}
              className="group hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border-2 border-transparent hover:border-cyan-200 overflow-hidden">

                <div className="relative h-48 overflow-hidden">
                  <img
                  src={service.image}
                  alt={`${service.title} – kutyakozmetika Miskolc, Észak-Kilián (kutya nyírás és kutya ápolás)`}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />

                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                </div>
                <CardHeader>
                  <div className="w-16 h-16 bg-gradient-to-br from-cyan-100 to-teal-100 rounded-2xl flex items-center justify-center mb-4 text-cyan-600 group-hover:scale-110 transition-transform duration-300">
                    {service.icon}
                  </div>
                  <CardTitle className="text-2xl text-gray-800">{service.title}</CardTitle>
                  <CardDescription className="text-base text-gray-600 leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardHeader>
              </Card>
            )}
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="araink" className="py-16 sm:py-20 bg-gradient-to-br from-cyan-50 via-white to-teal-50">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-cyan-600 to-teal-600 bg-clip-text text-transparent">
                Áraink
              </h2>
            </div>
            <Card className="shadow-xl border-2 border-cyan-100 overflow-hidden">
              <CardContent className="p-6 sm:p-8 md:p-10">
                <div className="space-y-5 text-base sm:text-lg text-gray-700 leading-relaxed text-center">
                  <p>
                    Szolgáltatásaink díjszabása minden esetben egyedi, amely függ a kutya méretétől, fajtájától és a szőrzet aktuális állapotától. A pontos árakat és a részleteket minden vendégünkkel előre, a telefonos időpont-egyeztetés során beszéljük meg.
                  </p>
                  <p className="text-lg sm:text-xl font-semibold text-cyan-700">
                    Hívjon minket bizalommal a pontos árajánlatért!
                  </p>
                  <div className="pt-2">
                    <Button
                      size="lg"
                      className="bg-gradient-to-r from-cyan-500 to-teal-500 hover:from-cyan-600 hover:to-teal-600 text-white font-bold px-6 sm:px-8 py-5 sm:py-6 text-base sm:text-lg rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 w-full sm:w-auto"
                      onClick={() => window.location.href = 'tel:06305441284'}>

                      <Phone className="w-5 h-5 mr-2" />
                      06 30 544 1284
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-16 sm:py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-10 sm:mb-12">
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-cyan-600 to-teal-600 bg-clip-text text-transparent">Rólam

              </h2>
            </div>
            <Card className="shadow-xl border-2 border-cyan-100 overflow-hidden">
              <CardContent className="p-6 sm:p-8 md:p-10">
                <div className="space-y-6 text-base sm:text-lg text-gray-700 leading-relaxed">
                  <p>
                    A <strong className="text-cyan-600">Mázli Kutyakozmetika</strong> Miskolcon, a Fehér Akác Lakópark szívében várja szeretettel négylábú barátait és gazdikat.
                  </p>
                  <p>Tapasztalt szakember ként minden kutyát egyedi figyelemmel és gondoskodással kezelem. Célom, hogy kedvenceim nemcsak szépen, hanem boldogan és kipihenve hagyják el szalonomat.

                  </p>
                  <p>Prémium minőségű termékeket használok, és fajtaspecifikus tudással rendelkezek minden típusú szőrzet kezeléséhez. Nálam biztonságban vannak kis kedvencei!

                  </p>
                  <div className="flex items-center gap-3 pt-4 border-t border-cyan-100 mt-8">
                    <PawPrint className="w-8 h-8 text-cyan-500" />
                  <p className="text-base sm:text-lg lg:text-xl font-semibold text-gray-800 italic">
                      "Minden kutya megérdemli a legjobb ápolást!"
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Before & After Section */}
      <section className="py-16 sm:py-20 bg-gradient-to-br from-slate-50 to-cyan-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-cyan-600 to-teal-600 bg-clip-text text-transparent">
              Előtte & Utána
            </h2>
            <p className="text-lg sm:text-xl text-gray-600">
              Lenyűgöző átalakulások professzionális ápolással
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-6 sm:gap-8 max-w-7xl mx-auto">
            {beforeAfterImages.map((item) =>
            <Card
              key={item.id}
              className="overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border-2 border-cyan-100">

                <CardHeader className="bg-gradient-to-r from-cyan-50 to-teal-50">
                  <CardTitle className="text-xl text-center text-gray-800">{item.title}</CardTitle>
                </CardHeader>
                <CardContent className="p-0">
                  <div className="grid grid-cols-2">
                    {/* Before */}
                    <div className="relative group">
                      <div className="absolute top-3 left-3 z-10 bg-red-500 text-white px-3 py-1 rounded-full text-sm font-bold shadow-lg">
                        Előtte
                      </div>
                      <img
                      src={item.before}
                      alt={`${item.title} kutya ápolás előtt – kutyakozmetika Miskolc Észak-Kilián`}
                      className="w-full h-48 sm:h-56 lg:h-64 object-cover grayscale-[20%]" />

                      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/30"></div>
                    </div>
                    {/* After */}
                    <div className="relative group">
                      <div className="absolute top-3 right-3 z-10 bg-green-500 text-white px-3 py-1 rounded-full text-sm font-bold shadow-lg">
                        Utána
                      </div>
                      <img
                      src={item.after}
                      alt={`${item.title} kutya nyírás után – Mázli Kutyakozmetika Miskolc`}
                      className="w-full h-48 sm:h-56 lg:h-64 object-cover" />

                      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/20"></div>
                    </div>
                  </div>
                  <div className="p-4 bg-white">
                    <div className="flex items-center justify-center gap-3">
                      <div className="flex items-center gap-2 text-sm text-gray-600">
                        <div className="w-3 h-3 bg-red-500 rounded-full"></div>
                        <span>Előtte</span>
                      </div>
                      <div className="text-cyan-600 font-bold">→</div>
                      <div className="flex items-center gap-2 text-sm text-gray-600">
                        <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                        <span>Utána</span>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            )}
          </div>
          <div className="text-center mt-12">
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">Minden kutyus egyedi figyelmet és szakszerű ápolást kap nálam. A különbség látható és tapintható!


            </p>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-16 sm:py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-cyan-600 to-teal-600 bg-clip-text text-transparent">Ügyfeleim Mondták

            </h2>
            <p className="text-lg sm:text-xl text-gray-600">
              Elégedett gazdik és boldog kutyusok
            </p>
          </div>
          <div className="max-w-5xl mx-auto">
            <div className="grid md:grid-cols-3 gap-6 sm:gap-8">
              {testimonials.map((testimonial) =>
              <Card
                key={testimonial.id}
                className="hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border-2 border-cyan-100">

                  <CardHeader>
                    <div className="flex gap-1 mb-3">
                      {[...Array(testimonial.rating)].map((_, i) =>
                    <svg key={`${testimonial.id}-star-${i}`} className="w-5 h-5 fill-yellow-400" viewBox="0 0 20 20">
                          <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                        </svg>
                    )}
                    </div>
                    <CardTitle className="text-xl text-gray-800">{testimonial.name}</CardTitle>
                    <CardDescription className="text-cyan-600 font-medium">{testimonial.dog}</CardDescription>
                  </CardHeader>
                  <CardContent>
                    <p className="text-gray-600 italic leading-relaxed">"{testimonial.text}"</p>
                  </CardContent>
                </Card>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Contact & Location Section */}
      <section className="py-16 sm:py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-cyan-600 to-teal-600 bg-clip-text text-transparent">
              Kapcsolat & Elérhetőség
            </h2>
            <p className="text-lg sm:text-xl text-gray-600">Találj meg engem könnyen!

            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-8 md:gap-12 max-w-6xl mx-auto">
            <Card className="shadow-xl border-2 border-cyan-100">
              <CardHeader>
                <CardTitle className="text-2xl text-cyan-700">Elérhetőségeim</CardTitle>
              </CardHeader>
              <CardContent className="space-y-6">
                <div className="flex items-start gap-4 p-4 bg-cyan-50 rounded-xl hover:bg-cyan-100 transition-colors">
                  <MapPin className="w-6 h-6 text-cyan-600 mt-1 flex-shrink-0" />
                  <div>
                    <p className="font-semibold text-gray-800 mb-1">Cím:</p>
                    <p className="text-gray-700">3534 Miskolc, Észak-Kilián</p>
                    <p className="text-gray-700">Róna u 1-2. (Fehér Akác Lakópark)</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 p-4 bg-teal-50 rounded-xl hover:bg-teal-100 transition-colors">
                  <Phone className="w-6 h-6 text-teal-600 mt-1 flex-shrink-0" />
                  <div>
                    <p className="font-semibold text-gray-800 mb-1">Telefon:</p>
                    <a
                      href="tel:06305441284"
                      className="text-xl font-bold text-teal-600 hover:text-teal-700 transition-colors">

                      06 30 544 1284
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-4 p-4 bg-blue-50 rounded-xl hover:bg-blue-100 transition-colors">
                  <Facebook className="w-6 h-6 text-blue-600 mt-1 flex-shrink-0" />
                  <div>
                    <p className="font-semibold text-gray-800 mb-1">Facebook:</p>
                    <a
                      href="https://www.facebook.com/mazlikutyakozmetikamiskolc"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:text-blue-700 font-medium transition-colors hover:underline">

                      Mázli Kutyakozmetika Miskolc
                    </a>
                  </div>
                </div>
                <Button
                  className="w-full bg-gradient-to-r from-cyan-500 to-teal-500 hover:from-cyan-600 hover:to-teal-600 text-white font-bold py-6 text-lg rounded-xl shadow-lg hover:shadow-xl transition-all duration-300"
                  onClick={() => window.location.href = 'tel:06305441284'}>

                  <Phone className="w-5 h-5 mr-2" />
                  Időpontfoglalás most
                </Button>
              </CardContent>
            </Card>

            <Card className="shadow-xl border-2 border-cyan-100 overflow-hidden">
              <CardHeader>
                <CardTitle className="text-2xl text-cyan-700">Találjon meg engem</CardTitle>
              </CardHeader>
              <CardContent className="p-0">
                <div className="w-full h-72 sm:h-80 md:h-96">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2669.967!2d20.709112!3d48.10487!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNDjCsDA2JzE3LjUiTiAyMMKwNDInMzIuOCJF!5e0!3m2!1sen!2shu!4v1234567890"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Mázli Kutyakozmetika helyszín">
                  </iframe>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gradient-to-r from-gray-900 to-gray-800 text-white py-12">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <PawPrint className="w-8 h-8 text-cyan-400" />
                <h3 className="text-2xl font-bold">Mázli Kutyakozmetika</h3>
              </div>
              <p className="text-gray-400">
                Professzionális kutyakozmetika Miskolcon, szeretettel és szakértelemmel.
              </p>
            </div>
            <div>
              <h4 className="text-xl font-semibold mb-4 text-cyan-400">Gyors linkek</h4>
              <ul className="space-y-2 text-gray-400">
                <li>
                  <a href="#services" className="hover:text-cyan-400 transition-colors">Szolgáltatások</a>
                </li>
                <li>
                  <a href="tel:06305441284" className="hover:text-cyan-400 transition-colors">Időpontfoglalás</a>
                </li>
                <li>
                  <a href="https://www.facebook.com/mazlikutyakozmetikamiskolc" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition-colors">
                    Facebook
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-xl font-semibold mb-4 text-cyan-400">Elérhetőség</h4>
              <ul className="space-y-2 text-gray-400">
                <li className="flex items-center gap-2">
                  <Phone className="w-4 h-4" />
                  <a href="tel:06305441284" className="hover:text-cyan-400 transition-colors">06 30 544 1284</a>
                </li>
                <li className="flex items-start gap-2">
                  <MapPin className="w-4 h-4 mt-1 flex-shrink-0" />
                  <span>3534 Miskolc, Észak-Kilián, Róna u 1-2.</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-700 pt-8 mb-8">
            <div className="flex flex-wrap items-center gap-x-6 gap-y-2 mb-4">
              <h4 className="text-xl font-semibold text-cyan-400">Impresszum</h4>
              <Link
                to="/adatkezelesi-tajekoztato"
                data-testid="privacy-link-footer"
                className="text-cyan-400 hover:text-cyan-300 underline underline-offset-4 transition-colors text-sm font-medium">
                Adatkezelési Tájékoztató
              </Link>
            </div>
            <div className="text-gray-400 text-sm leading-relaxed space-y-1">
              <p><span className="text-gray-300 font-medium">Szolgáltató:</span> Orbán Renáta E.V.</p>
              <p><span className="text-gray-300 font-medium">Székhely:</span> 3534 Miskolc, Árpád út 46. 6/1.</p>
              <p><span className="text-gray-300 font-medium">Adószám:</span> 91570189-1-25</p>
              <p><span className="text-gray-300 font-medium">Nyilvántartási szám:</span> 61434644</p>
              <p>
                <span className="text-gray-300 font-medium">Telefonszám:</span>{' '}
                <a href="tel:06305441284" className="hover:text-cyan-400 transition-colors">06 30 544 1284</a>
              </p>
              <p>
                <span className="text-gray-300 font-medium">Tárhelyszolgáltató:</span> Emergent Labs Inc. (1111B S Governors Ave STE 21453, Dover, DE 19904, USA,{' '}
                <a href="mailto:support@emergent.sh" className="hover:text-cyan-400 transition-colors">support@emergent.sh</a>)
              </p>
            </div>
          </div>
          <div className="border-t border-gray-700 pt-8 text-center text-gray-400">
            <p>&copy; 2025 Mázli Kutyakozmetika. Minden jog fenntartva.</p>
          </div>
        </div>
      </footer>

      {/* Floating Call Button */}
      <a
        href="tel:06305441284"
        className="fixed bottom-8 right-8 bg-gradient-to-r from-cyan-500 to-teal-500 hover:from-cyan-600 hover:to-teal-600 text-white p-5 rounded-full shadow-2xl hover:shadow-cyan-500/50 transition-all duration-300 transform hover:scale-110 z-50 flex items-center justify-center group"
        aria-label="Hívás">

        <Phone className="w-7 h-7 group-hover:animate-pulse" />
      </a>
    </div>);

};

export default Home;